import { useHttp } from '@/shared/lib'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'

export const useLoadWidgetEvents = (data: any) => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => {
    const searchParams = new URLSearchParams(data)
    return `/object-events/${route.params.object_id}/events?${searchParams}`
  })

  const queryKey = computed(() => ['events_widget', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
